import { render } from "./CarouselBerita.vue?vue&type=template&id=76e4050f"
import script from "./CarouselBerita.vue?vue&type=script&lang=js"
export * from "./CarouselBerita.vue?vue&type=script&lang=js"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__